import { render, staticRenderFns } from "./EmptyComponent.vue?vue&type=template&id=085db356&scoped=true&"
import script from "./EmptyComponent.vue?vue&type=script&lang=ts&"
export * from "./EmptyComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085db356",
  null
  
)

export default component.exports